import moment from 'moment';
import {
  VAR_CUSTOMER_NAME,
  VAR_DATE_AND_START_TIME,
  VAR_SERVICE_NAME,
  VAR_PROFESSIONAL_NAME,
  VAR_COURT_NAME,
  VAR_TOTAL_SERVICE_VALUE_NAME,
} from './messageConstants';
import NumberUtils from './numberUtils';

const CALENDAR_FORMAT_CONFIG = {
  sameDay: '([Hoje]) D [de] MMMM',
  nextDay: '([Amanhã]) D [de] MMMM',
  lastDay: 'D [de] MMMM',
  lastWeek: 'D [de] MMMM',
  nextWeek: '(dddd) D [de] MMMM',
  sameElse: '(dddd) D [de] MMMM',
};

export function prepareMessageForAllVariables({
  message,
  customerName,
  serviceName,
  date,
  startTime,
  professionalName,
  totalServiceValue,
  isCourtRental,
}) {
  let selectedMsgString = message;
  if (customerName) {
    const nameParts = customerName.trim().split(' ');
    if (nameParts.length > 0) {
      selectedMsgString = selectedMsgString.replace(VAR_CUSTOMER_NAME, nameParts[0]);
    } else {
      selectedMsgString = selectedMsgString.replace(VAR_CUSTOMER_NAME, '');
    }
  } else {
    selectedMsgString = selectedMsgString.replace(VAR_CUSTOMER_NAME, '');
  }

  if (professionalName) {
    const nameParts = isCourtRental ? [professionalName.trim()] : professionalName.trim().split(' ');
    if (nameParts.length > 0) {
      selectedMsgString = selectedMsgString.replace(
        isCourtRental ? VAR_COURT_NAME : VAR_PROFESSIONAL_NAME,
        nameParts[0],
      );
    } else {
      selectedMsgString = selectedMsgString.replace(
        isCourtRental ? VAR_COURT_NAME : VAR_PROFESSIONAL_NAME,
        '',
      );
    }
  } else {
    selectedMsgString = selectedMsgString.replace(isCourtRental ? VAR_COURT_NAME : VAR_PROFESSIONAL_NAME, '');
  }

  if (serviceName) {
    selectedMsgString = selectedMsgString.replace(VAR_SERVICE_NAME, serviceName);
  }
  if (date && startTime) {
    const formattedDate = moment(date).calendar(null, CALENDAR_FORMAT_CONFIG);
    selectedMsgString = selectedMsgString.replace(
      VAR_DATE_AND_START_TIME,
      `dia ${formattedDate} às ${startTime}`,
    );
  }

  if (totalServiceValue && totalServiceValue !== '') {
    selectedMsgString = selectedMsgString.replace(
      VAR_TOTAL_SERVICE_VALUE_NAME,
      NumberUtils.toCurrency(totalServiceValue),
    );
  } else {
    selectedMsgString = selectedMsgString.replace(VAR_TOTAL_SERVICE_VALUE_NAME, '-');
  }

  return selectedMsgString;
}
